import { createAction, props } from '@ngrx/store';

import { ErrorResponse } from '#types/core';
import { MultipleListOfValuesResponse } from '#types/list';

//
// user / request lists
//

export const RequestLists = createAction('[User] - Request Lists');

//
// user lists
//

export const RequestUserLists = createAction('[User.Lists] - Request User Lists');
export const RequestUserListsSuccess = createAction(
  '[User.Lists] - Request User Lists Success',
  props<{ lists: MultipleListOfValuesResponse }>()
);
export const RequestUserListsFailure = createAction('[User.Lists] - Request User Lists Failure', props<{ error: ErrorResponse }>());
